// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FranchisorChannels_ChannelRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * FranchisorChannels_ChannelRow — one row of `franchisor_channels` for the
 * Full-only console (S13 · B4).
 *
 * `api_key` is ALWAYS the masked form (Franchisor_channels_model::listAll()
 * / find() never return the raw secret) — '****' + last 4 chars, or null
 * when no key is stored. The raw value never leaves the model.
 *
 * `enabled_triggers` is DERIVED by the controller from
 * franchisor_channel_triggers (every ENABLED binding whose channel_id is
 * this row's id) — the console's "chips" of what this channel is currently
 * wired to fire on.
 */
import { registerContract } from './validate'

export interface FranchisorChannels_ChannelRow {
id: number
name?: string
type?: string
provider?: string
api_key?: string
sender?: string
enabled?: boolean
enabled_triggers?: string[]
created_at?: string
updated_at?: string
}

registerContract('FranchisorChannels_ChannelRow', {
  id:               { type: 'number',  required: true },
  name:             { type: 'string',  required: false },
  type:             { type: 'string',  required: false },
  provider:         { type: 'string',  required: false },
  api_key:          { type: 'string',  required: false },
  sender:           { type: 'string',  required: false },
  enabled:          { type: 'boolean', required: false },
  enabled_triggers: { type: 'array',   required: false },
  created_at:       { type: 'string',  required: false },
  updated_at:       { type: 'string',  required: false },
})
